module.exports = __webpack_public_path__ + "static/media/sprintbot2.2a349a13.png";